import type { Config } from '#/schemas/config';

/** Reads and removes a client configuration cookie when browser APIs exist. */
export function getCookie(cookieName: string): Config | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const cookies = document.cookie;
  const startPosition = cookies.search(`${cookieName}=`);

  if (startPosition === -1) {
    return null;
  }

  const cookieAssignment = cookies.slice(startPosition).split(';', 1).join('');
  const [, encodedCookie = ''] = cookieAssignment.split('=');
  const cookie = decodeURIComponent(encodedCookie);

  if (typeof window !== 'undefined' && 'cookieStore' in window) {
    void window.cookieStore.delete(cookieName);
  }

  let value: unknown = cookie;
  if (cookie.charAt(0) === '{') {
    value = JSON.parse(cookie);
  }

  return value as Config;
}
